import isServer from 'detect-node';
export function getMutationObserver() {
    if (isServer) {
        return (function () {
            function class_1() {
            }
            class_1.prototype.observe = function () {
            };
            class_1.prototype.disconnect = function () {
            };
            class_1.prototype.takeRecords = function () {
                return [];
            };
            return class_1;
        }());
    }
    else {
        return MutationObserver;
    }
}
